import Vue from 'vue';
// eslint-disable-next-line import/order
import App from './App.vue';

// Vuetify Dependecies
import Vuetify from 'vuetify';
import VuetifyToast from 'vuetify-toast-snackbar';
import 'vuetify/dist/vuetify.min.css';
import fr from 'vuetify/es5/locale/fr';

// Algolia Instant Search
import InstantSearch from 'vue-instantsearch';

import router from './router';
import store from './store';

import { isAuthenticated, getSSOLink, getToken } from '@/utils/auth';

router.beforeResolve(async (to, from, next) => {
  // Re-read the token on each navigation (handles chunked cookies + fresh login)
  const token = getToken();
  if (token !== store.state.token) {
    store.commit('setToken', token);
  }

  const isLogged = await isAuthenticated(token, window.location.origin);

  if (!isLogged) {
    window.localStorage.clear();
    window.location.href = getSSOLink(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
    return false;
  }

  return next();
});

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: false,
    themes: { light: { primary: '#c71900' } }
  },
  lang: {
    locales: { fr },
    current: 'fr'
  }
};

const vueObj = new Vuetify(opts);

Vue.use(InstantSearch);

Vue.use(VuetifyToast, {
  $vuetify: vueObj.framework,
  classes: [
    'body-2',
    'ml-2',
    'mb-2'
  ]
});

Vue.config.productionTip = false;
// Vue.config.devtools = true;

new Vue({
  router,
  store,
  vuetify: vueObj,
  render: h => h(App),
  beforeCreate () {
    // If its not a keep alive route
    if (!this.$route.meta.keepAlive) {
      store.commit('setInclude', [this.$route.meta.componentName]);
    }
  }
}).$mount('#app');
